import * as angular from "angular";
import {IController} from "angular";

export class LogisticsVehiclesTableCtrl implements IController {

  infiniteScroll: any;
  isScrollable: boolean;
  onViewLogisticsVehicleClicked: Function;
  onUnbindVehicle: Function;
  onLogisticsVehicleDeleted: Function;

  public siteDistanceUnit: string;

  constructor(private splitService) {
    this.siteDistanceUnit = splitService.getSiteDistanceLargeUnit(true);
  }

  $onInit() {
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.infiniteScroll && !changes.infiniteScroll.isFirstChange()) {
      this.$onInit();
    }
  }
}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('logisticsVehiclesTable', {
    bindings: {
      infiniteScroll: '<?',
      isScrollable: '<?',
      onViewLogisticsVehicleClicked: '&',
      onUnbindVehicle: '&',
      onLogisticsVehicleDeleted: '&'
    },
    template: require('./logistics-vehicles-table.html').default,
    controller: LogisticsVehiclesTableCtrl
  });
